// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HubV1GetPatientDefaultResponse {
    static getAttributeTypeMap() {
        return HubV1GetPatientDefaultResponse.attributeTypeMap;
    }
}
HubV1GetPatientDefaultResponse.discriminator = undefined;
HubV1GetPatientDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PatientModel"
    }
];
//# sourceMappingURL=hubV1GetPatientDefaultResponse.js.map